module.exports = __webpack_public_path__ + "static/media/DECLAWED.479bafac.svg";